import {trackEvent} from "../../library/analytics";
import {isMobile} from "../../website/webpack/modules/devices";

$(document).ready(function(){
    $(document).on('submit', '.loginForm', function(e) {
        e.preventDefault();
        let form = $(this);
        let url = form.attr('action');
        let data = form.serialize();
        let analyticsCategory = form.data('scope');
        trackEvent(analyticsCategory, 'SignIn', 'Login');
        $('.responseLogin').empty();
        $.post(
            url,
            data,
            function(data){
                if (data.done) {
                    dataLayer.push(
                        {
                            "event": "login",
                            "method": "form"
                        }
                    );
                    if (data.url){
                        window.location.replace(data.url);
                    } else {
                        $('.login-check-modal').modal('hide');
                    }
                } else {
                    $('.responseLogin').html(data.msg);
                    if (isMobile()) {
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    }
                }
            },
            'json'
        );
    });
    $(document).on('click', '.sendRecoverBtn', function() {
        let recoverMail = $(this).parents('.recoverPass').find('[name="recoverMail"]').val();
        let analyticsCategory = $(this).data('scope');
        trackEvent(analyticsCategory, 'SignIn', 'RecoverPassword');
        $.post(
            '/ajax/website/user/ask-recovery-password',
            {email: recoverMail},
            function(data){
                if(data.done) {
                    $('.error-response').addClass('hidden');
                    $('.success-response').html(data.message);
                    $('.success-response').removeClass('hidden');
                    setTimeout(function() {
                        $('.success-response').empty();
                        $('.success-response').addClass('hidden');
                        $('.responseLogin').empty();
                        $('.recoverPass').slideUp('fast');
                        $('.loginForm').slideDown('fast');
                        $('.no-register').slideDown('fast');
                    }, 4000);
                } else {
                    $('.success-response').addClass('hidden');
                    $('.error-response').html(data.message);
                    $('.error-response').removeClass('hidden');
                    if (isMobile()) {
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    }
                }
            },
            'json'
        );
    });

    $(document).on('submit', '.registerForm', function(e) {
        e.preventDefault();
        let form = $(this);
        let url = form.attr('action');
        let data = form.serialize();
        let analyticsCategory = form.data('scope');
        trackEvent(analyticsCategory, 'NewUser', 'Register');
        $('.responseRegister').empty();
        $.post(
            url,
            data,
            function(data){
                if (data.done) {
                    trackEvent('UserSignIn', 'Register', '');
                    dataLayer.push(
                        {
                            "event": "sign_up",
                            "method": "form"
                        }
                    );
                    if (data.url){
                        window.location.replace(data.url);
                    } else {
                        $('.login-check-modal').modal('hide');
                    }
                } else {
                    trackEvent('RegisterLogin', 'Register', 'error');
                    $('.responseRegister').html(data.msg);
                    if (isMobile()) {
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    }
                }
            },
            'json'
        );
    });
    $(document).on('click', '.showRecoverPass', function() {
        $('.responseLogin, .responseRegister').empty();
        $('.loginForm').slideUp('fast');
        $('.no-register').slideUp('fast');
        $('.recoverPass').slideDown('fast');
    });
    $(document).on('click', '.sendRecoverClose', function() {
        $('.responseLogin, .responseRegister').empty();
        $('.recoverPass').slideUp('fast');
        $('.loginForm').slideDown('fast');
        $('.no-register').slideDown('fast');
    });
    $(document).on('click', '.showRegister', function() {
        $('.responseLogin, .responseRegister').empty();
        $('.loginForm').slideUp('fast');
        $('.no-register').slideUp('fast');
        $('.registerForm').slideDown('fast', function() {
            google.accounts.id.renderButton(
                document.querySelector('.registerForm').querySelector('.g_id_signin'),
                { type: "icon", size: "large", theme: "outline" }  // customization attributes
            );
        });
    });
    $(document).on('click', '.backLogin', function () {
        $('.responseLogin, .responseRegister').empty();
        $('.loginForm').slideDown('fast', function() {
            google.accounts.id.renderButton(
                document.querySelector('.loginForm').querySelector('.g_id_signin'),
                { type: "icon", size: "large", theme: "outline" }  // customization attributes
            );
        });
        $('.no-register').slideDown('fast');
        $('.registerForm').slideUp('fast');
    });

    // NEW LOGIN
    $(document).on('submit', '#check-email-form', function(e) {
        e.preventDefault();
        let email = $(this).find('input[name="email"]').val();
        $.post(
            $(this).attr('action'),
            {
                email: email
            },
            function(data){
                let exists = data.exists;
                $(".login form input[type='email']").val(email);
                $('#form-check-email-container').hide();
                if (exists) $('#form-login-container').show();
                else $('#form-register-container').show();
            }
        );
    });

    $(document).on('submit', '#register-form', function(e) {
        e.preventDefault();
        let form = $(this);
        trackEvent(form.data('scope'), 'NewUser', 'Register');
        form.find('.error-message').empty();

        $.post(
            form.attr('action'),
            {
                name: form.find('input#user-register-name').val(),
                email: form.find('input#user-register-email').val(),
                repEmail: form.find('input#user-register-email').val(),
                pass: form.find('input#user-register-password').val(),
                repPass: form.find('input#user-register-repeat-password').val(),
                redirectUrl: form.find('input#register-redirect-url').val()
            },
            function(data){
                if (data.done) {
                    trackEvent('UserSignIn', 'Register', '');
                    dataLayer.push({"event": "sign_up", "method": "form"});
                    if (form.closest('.login-check-modal').length) $('.login-check-modal').modal('hide');
                    else if (data.url) window.location.replace(data.url);
                } else {
                    trackEvent('RegisterLogin', 'Register', 'error');
                    form.find('.error-message').html(data.msg);
                    if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
                }
            }
        );
    });

    $(document).on('submit', '#login-form', function(e) {
        e.preventDefault();
        let form = $(this);
        trackEvent(form.data('scope'), 'SignIn', 'Login');
        form.find('.error-message').empty();
        $.post(
            form.attr('action'),
            {
                email: form.find('input#user-login-email').val(),
                pass: form.find('input#user-login-password').val(),
                redirectUrl: form.find('input#login-redirect-url').val()
            },
            function(data){
                if (data.done) {
                    dataLayer.push({"event": "login", "method": "form"});
                    if (form.closest('.login-check-modal').length) $('.login-check-modal').modal('hide');
                    else if (data.url) window.location.replace(data.url);
                } else {
                    form.find('.error-message').html(data.msg);
                    if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
                }
            }
        );
    });

    $(document).on('click', '.login .modify-button', function() {
        $('#form-register-container, #form-login-container, #form-recovery-password-container').hide();
        $("#form-check-email-container").show();
    });

    $(document).on('click', '.login .button-forget-password', function() {
        $('#form-login-container').hide();
        $("#form-recovery-password-container").show();
    });

    $(document).on('submit', '#recovery-password-form', function(e) {
        e.preventDefault();
        let form = $(this);
        trackEvent(form.data('scope'), 'SignIn', 'Login');
        form.find('.error-message, .success-message').empty();

        $.post(
            form.attr('action'),
            {
                email: form.find('input#recovery-password-email').val()
            },
            function(data){
                if (data.done) {
                    form.find('.error-message').addClass('hidden');
                    form.find('.success-message').html(data.message);
                    form.find('.success-message').removeClass('hidden');
                    setTimeout(function() {
                        form.find('.success-message').empty();
                        form.find('.success-message').addClass('hidden');
                        $('#form-recovery-password-container').hide();
                        $("#form-login-container").show();
                    }, 4000);
                } else {
                    form.find('.success-message').addClass('hidden');
                    form.find('.error-message').html(data.message);
                    form.find('.error-message').removeClass('hidden');
                    if (isMobile()) window.scrollTo({top: 0, behavior: 'smooth'});
                }
            }
        );
    });

    $(document).on('click', '.login #custom-google-signin-button', function() {
        $("#hidden-google-button div[role=button]").click();
    });
});